import {
    Button,
    Card,
    CardBody, CardFooter,
    CardHeader,
    Divider, Image, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader,
    Progress,
    Spacer, Checkbox,
    Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Textarea
} from "@heroui/react";
import {PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer} from "recharts";
import ReactSpeedometer from "react-d3-speedometer";
import CustomSwitch from "../CustomSwitch";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {format} from "date-fns";
import {toZonedTime} from "date-fns-tz";
import {Icon} from "@iconify/react";
import {FaFileExcel, FaFilePdf, FaFileWord} from "react-icons/fa";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import DownloadZipButton from "../DownloadZipButton";
import {ChevronDownIcon} from "lucide-react";
import { apiClient, currentBaseURL } from "../../services/apiClient"; // Import currentURL
import { toast } from "sonner";

export default ({rskRef, approveView = false, claimId = null, isBusy, setIsBusy, rowAprobado, onTitleLoaded}) => {
    //rskRef = "RSK2024/110"
    const filesEndpoint = `${currentBaseURL}/quickview/adjunto/`;
    const [selectedFile, setSelectedFile] = useState(null); //archivo a visializar modal documentos
    const [isFileModalOpen, setIsFileModalOpen] = useState(false); // modal documentos
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); //dropdown detalles de extra costs
    const [surveyData, setSurveyData] = useState(undefined);
    //LightBox
    const [selectedImage, setSelectedImage] = useState(null);
    const [open, setOpen] = useState(false);
    const [editEnabled, setEditEnabled] = useState(false);
    const [filesToUpload, setFilesToUpload] = useState([]);

    //./LightBox
    const [chartData, setChartData] = useState([
        { subject: 'Shipping Docs', A: 0, fullMark: 100 },
        { subject: 'Support Evidence', A: 0, fullMark: 100 },
        { subject: 'Sales Result', A: 0, fullMark: 100 },
        { subject: 'Claiming Documents', A: 0, fullMark: 100 },
        { subject: 'Temp', A: 0, fullMark: 100 },
        { subject: 'CA', A: 0, fullMark: 100 },
        { subject: 'Delay', A: 0, fullMark: 100 },
    ]);

    // Llamada al endpoint al montar el componente
    useEffect(() => {
        const fetchClaims = async () => {
            try {
                const response = await apiClient.get(`/quickview/claimsurvey?column=rsk_ref&value=${rskRef}`);
                setSurveyData(response.data);
                console.log(response.data)
                
                // Enviar el título al componente padre cuando se carguen los datos
                if (onTitleLoaded && response.data?.quickview_claim) {
                    const title = `${response.data.quickview_claim.rsk_ref?.replace(/\//g, "-")} / ${response.data.quickview_claim.exporter_name} / ${response.data.quickview_claim.vessel} / ${response.data.quickview_claim.bl_awb ? response.data.quickview_claim.bl_awb.replace(/-/g, '') : response.data.quickview_claim.bl_awb} / ${response.data.quickview_claim.container_number}`;
                    onTitleLoaded(title);
                }
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        };
        fetchClaims();
    }, [rskRef, onTitleLoaded]);

    useEffect(() => {
        if (surveyData !== undefined) {
            const updatedData = [
                { subject: 'Shipping Docs', A: surveyData?.quickview_claim_survey?.shippingdocsscore ?? 0, fullMark: 100 },
                { subject: 'Support Evidence', A: surveyData?.quickview_claim_survey?.supportevidencescore ?? 0, fullMark: 100 },
                { subject: 'Sales Result', A: surveyData?.quickview_claim_survey?.salesresultsscore ?? 0, fullMark: 100 },
                { subject: 'Claiming Documents', A: surveyData?.quickview_claim_survey?.claimingdocsscore ?? 0, fullMark: 100 },
                { subject: 'Temp', A: surveyData?.quickview_claim_survey?.meritstempscore ?? 0, fullMark: 100 },
                { subject: 'CA', A: surveyData?.quickview_claim_survey?.meritsgasscore ?? 0, fullMark: 100 },
                { subject: 'Delay', A: surveyData?.quickview_claim_survey?.meritsdelayscore ?? 0, fullMark: 100 },
            ];
            setChartData(updatedData);
        }
    }, [surveyData]);

    // useEffect para escuchar el evento personalizado de aprobación
    useEffect(() => {
        const handleReclamoAprobado = (event) => {
            const { rskRef: eventRskRef, a_cargo } = event.detail;
            
            // Solo actualizar si el rskRef coincide
            if (eventRskRef === rskRef) {
                setSurveyData(prevData => {
                    if (prevData && prevData.maestra) {
                        return {
                            ...prevData,
                            maestra: {
                                ...prevData.maestra,
                                a_cargo: a_cargo
                            }
                        };
                    }
                    return prevData;
                });
            }
        };

        // Agregar event listener
        window.addEventListener('reclamoAprobado', handleReclamoAprobado);

        // Cleanup
        return () => {
            window.removeEventListener('reclamoAprobado', handleReclamoAprobado);
        };
    }, [rskRef]);

    const headerFields = [
        { icon: "lucide:hash", label: "Claim Number", value: surveyData?.quickview_claim.rsk_ref},
        { icon: "lucide:shopping-basket", label: "Exporter", value: surveyData?.quickview_claim.exporter_name },
        { icon: "lucide:shopping-cart", label: "Product", value: surveyData?.maestra.especie },
        { icon: "lucide:container", label: "Container Number", value: surveyData?.quickview_claim.container_number },
        { icon: "lucide:ship-wheel", label: "Port of Loading (POL)", value: surveyData?.quickview_claim.pol },
        { icon: "lucide:ship-wheel", label: "Port of Discharge (POD)", value: surveyData?.quickview_claim.pod },
        { icon: "lucide:ship", label: "Vessel Name", value: surveyData?.quickview_claim.vessel },
        { icon: "lucide:receipt-text", label: "Bill of Lading (B/L) Number", value: surveyData?.quickview_claim.bl_awb ? surveyData.quickview_claim.bl_awb.replace(/-/g, '') : surveyData?.quickview_claim.bl_awb },
        { icon: "lucide:user", label: "Carrier", value: surveyData?.quickview_claim.carrier_name },
        { icon: "lucide:calendar", label: "ETA", 
            value: surveyData?.quickview_claim?.eta 
                ? format(toZonedTime(new Date(surveyData.quickview_claim.eta), "UTC"), "dd-MM-yyyy")
                : "N/A"
        },
        { icon: "lucide:calendar", label: "ATA", 
            value: surveyData?.quickview_claim?.ata 
                ? format(toZonedTime(new Date(surveyData.quickview_claim.ata), "UTC"), "dd-MM-yyyy")
                : "N/A"
        },
        { icon: "lucide:hash", label: "Causa", value: surveyData?.maestra?.causa || "N/A" },
        { icon: "lucide:hash", label: "A cargo", value: surveyData?.maestra?.a_cargo || "N/A" }
    ]

    const perdidaCalculadaConsignment = [
        { icon: "lucide:dollar-sign", label: "Sound Market Value (SMV)",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.consign_sound_market_value || 0)
        },
        {
            icon: "lucide:dollar-sign", icon2: "lucide:minus", label: "Actual Sales Value",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.consign_actual_sales_value || 0)
        },
        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Loss Due to Damage",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.consign_loss_due_damage || 0)
        },
        {
            icon: "lucide:dollar-sign",
            icon2: "lucide:plus",
            label: "Total Extra Costs Incurred (if any)",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(
                    surveyData?.extra_costs?.reduce((total, item) => {
                        // Verifica si item.value existe y conviértelo a número
                        const value = parseFloat(item.value) || 0;
                        return total + value;
                    }, 0) || 0
                ),
            hasDropdown: surveyData?.extra_costs?.length > 0 // Determina si debe mostrar un dropdown

        },
        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Claim Amount",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.claimamount || 0)
        },
    ];

    const insurancePayment = [

        { icon: "lucide:dollar-sign", label: "Insurance Payment",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.insurancepayment || 0)},
        { icon: "lucide:dollar-sign", label: "Deductible",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.deductible || 0)},
        { icon: "lucide:dollar-sign", label: "Not Covered",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.not_covered || 0)},
        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Claim Amount",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.claimamount || 0)
        },

    ]

    const perdidaCalculadaFirm = [
        { icon: "lucide:dollar-sign", label: "Invoice Value",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_invoice_value || 0)},
        {
            icon: "lucide:dollar-sign",
            icon2: "lucide:minus",
            label: "Sales",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_sales || 0),
            //Solo incluir si su valor no es nulo
            show: surveyData?.quickview_claim_survey.firm_sales != null
        },
        {
            icon: "lucide:dollar-sign",
            label: "Credit Note",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_credit_note || 0),
            //Solo incluir si su valor no es nulo
            show: surveyData?.quickview_claim_survey.firm_credit_note != null
        },
        { icon: "lucide:dollar-sign", icon2: "lucide:plus", label: "Freight",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_freight || 0)},
        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Loss Due Damage",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_loss_due_damage || 0)},
        { icon: "lucide:dollar-sign", icon2: "lucide:plus", label: "Destruction if Apply",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_destruction_if_apply || 0)},
        {
            icon: "lucide:dollar-sign",
            icon2: "lucide:plus",
            label: "Other Extra Expenses",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(
                    surveyData?.extra_costs?.reduce((total, item) => {
                        // Verifica si item.value existe y conviértelo a número
                        const value = parseFloat(item.value) || 0;
                        return total + value;
                    }, 0) || 0
                ),
            hasDropdown: surveyData?.extra_costs?.length > 0 // Determina si debe mostrar un dropdown

        },

        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Claim Amount",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.claimamount || 0)
        },
    ].filter(field => field.show !== false); // Filtrar los campos que no tienen `show: false`

    const quickViewDetails = [
        { icon: "lucide:ship-wheel", label: "Carrier", value: surveyData?.quickview_claim_survey.carrier },
        { icon: "lucide:hash", label: "Carrier Score", value: surveyData?.quickview_claim_survey.carrierscore },
        { icon: "lucide:message-circle-more", label: "Carrier Comment", value: surveyData?.quickview_claim_survey.carriercomment },
        { icon: "lucide:hash", label: "Total Structure Score", value: surveyData?.quickview_claim_survey.totalstructurescore },
        { icon: "lucide:circle-percent", label: "Hightest Merit Percentage", value: surveyData?.quickview_claim_survey.hightestmeritpercentage },
        { icon: "lucide:hash", label: "Final Recovery Score", value: surveyData?.quickview_claim_survey.finalrecoveryscore },
        { icon: "lucide:chevrons-up", label: "Upperbound", value: surveyData?.quickview_claim_survey.upperbound },
        { icon: "lucide:chevrons-down", label: "Lowerbound", value: surveyData?.quickview_claim_survey.lowerbound },
        { icon: "lucide:currency", label: "Selected Currency", value: surveyData?.quickview_claim_survey.selectedcurrency },
        { icon: "lucide:user", label: "Claimant", value: surveyData?.quickview_claim_survey.claimant },
        // { icon: "lucide:dollar-sign", label: "Insurance Payment", value: surveyData?.quickview_claim_survey.insurancepayment },
        // { icon: "lucide:dollar-sign", label: "Deductible", value: surveyData?.quickview_claim_survey.deductible },
        // { icon: "lucide:dollar-sign", label: "Not Covered", value: surveyData?.quickview_claim_survey.not_covered },
        // { icon: "lucide:message-circle-more", label: "General Comments", value: surveyData?.quickview_claim_survey.generalcomments },
        // { icon: "lucide:dollar-sign", label: "Claim Amount", value: surveyData?.quickview_claim_survey.claimamount },
    ];

    //modal documentos
    const openFileModal = (file) => {
        setSelectedFile(file);
        setIsFileModalOpen(true);
    };
    const closeFileModal = () => {
        setIsFileModalOpen(false);
        setSelectedFile(null);
    };
    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
        setOpen(true);
    };

    const handleCheckboxChange = async (index) => {
        const updatedAttachments = surveyData.attachments.map((file) =>
            file.id === index ? {...file, visible: !file.visible} : file
        );

        surveyData.attachments = updatedAttachments;

        setSurveyData({...surveyData});

        // Obtenemos el archivo actualizado con `find`
        const updatedFile = updatedAttachments.find((file) => file.id === index);

        console.log("updated file:", updatedFile)

        if (updatedFile) {
            setIsBusy(true);

            // fetch('https://quickview.rskgroupco.com/app/claims/adjunto', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify({id: updatedFile.id, visible: updatedFile.visible}),
            // })
            //     .then((response) => response.json())
            //     .then((data) => {
            //         console.log("Registro actualizado exitosamente:", data);
            //         setIsBusy(false);
            //     })
            //     .catch((error) => {
            //         console.error("Error al actualizar el registro:", error);
            //         setIsBusy(false);
            //     });

            try {
                const body = JSON.stringify({id: updatedFile.id, visible: updatedFile.visible});
                const response = await apiClient.post("/claims/adjunto", body, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                console.log("Registro actualizado exitosamente:", response.data);
            } catch (error) {
                console.error("Error al actualizar el registro:", error);
            } finally {
                setIsBusy(false);
            }
        }


    };

    return (
        <>
            {/* Condicional para mostrar contenido según el estado de surveyData */}
            {surveyData === undefined ? (
                // Mostrar spinner si surveyData es undefined
                // <Spinner color="primary" label="Cargando..." labelColor="primary" />
                <>
                    <p>Cargando...</p>
                    <Progress isIndeterminate aria-label="Cargando..." className="max-w-full" size="sm" />
                </>
            ) : surveyData === null ? (
                // Mostrar mensaje si surveyData es null
                <p>No hay datos disponibles.</p>
            ) : (

                <div>
                    {/*Mostrar las cards si surveyData tiene datos*/}
                    {/*HEADER*/}
                    <div className="max-w-full">
                        {/*<div className="p-4 max-w-full mx-auto">*/}
                        <Card className="w-full">
                            <CardBody>
                                <h2 className="text-2xl font-bold">{surveyData?.quickview_claim.rsk_ref?.replace(/\//g, "-")} / {surveyData?.quickview_claim.exporter_name} / {surveyData?.quickview_claim.vessel} / {surveyData?.quickview_claim.bl_awb ? surveyData.quickview_claim.bl_awb.replace(/-/g, '') : surveyData?.quickview_claim.bl_awb} / {surveyData?.quickview_claim.container_number}</h2>
                                <Divider className="my-4" />
                                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                    {headerFields.map((field, index) => (
                                        <div key={index} className="w-full">
                                            <Input
                                                isReadOnly
                                                label={field.label}
                                                value={field.value}
                                                startContent={
                                                    <Icon
                                                        icon={field.icon}
                                                        className="text-default-400 pointer-events-none flex-shrink-0"
                                                    />
                                                }
                                                classNames={{
                                                    label: "text-sm font-medium",
                                                    input: "text-sm"
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </CardBody>
                        </Card>
                    </div>

                    <Spacer />

                    {/*CARDS DE GAUGES*/}
                    <Card className="max-w-full flex flex-col items-center justify-center">
                        <CardHeader className="flex gap-3 justify-center">
                            <div className="flex flex-col">
                                <p className="text-md">Gauges</p>
                            </div>
                        </CardHeader>
                        <Divider />
                        <CardBody>
                            {/*RADAR CHART*/}
                            <ResponsiveContainer width="100%" height={350}>
                                <RadarChart cx="50%" cy="50%" outerRadius="90%" data={chartData}>
                                    <PolarGrid />
                                    <PolarAngleAxis dataKey="subject" />
                                    <PolarRadiusAxis angle={60} domain={[0, 100]} />
                                    <Radar
                                        name="Mike"
                                        dataKey="A"
                                        stroke="#8884d8"
                                        fill="#8884d8"
                                        fillOpacity={0.6}
                                        dot={({ cx, cy, index }) => {
                                            const value = chartData[index].A; // Obtiene el valor actual
                                            return (
                                                <g>
                                                    {/* Punto en el gráfico */}
                                                    <circle cx={cx} cy={cy} r={4} fill="#8884d8" />
                                                    {/* Etiqueta del valor */}
                                                    <text x={cx} y={cy - 10} textAnchor="middle" fontSize={10} fill="#8884d8">
                                                        {value}
                                                    </text>
                                                </g>
                                            );
                                        }}
                                    />
                                </RadarChart>
                            </ResponsiveContainer>
                        </CardBody>

                        <CardBody className="flex flex-col md:flex-row overflow-x-auto overflow-y-auto space-y-4 md:space-y-0 md:space-x-4">
                            <div className="flex flex-col md:flex-row flex-nowrap md:flex-wrap w-full justify-center items-center">
                                <div style={{ textAlign: "center" }}>
                                    <p><strong>Structure of the Claim</strong></p>
                                    <ReactSpeedometer //structure of the claim
                                        // Valor actual
                                        value={surveyData.quickview_claim_survey.totalstructurescore}
                                        // Rango máximo
                                        maxValue={400}
                                        // Rango mínimo
                                        minValue={0}
                                        // Número de segmentos (colores)
                                        segments={4}
                                        // Colores de los segmentos
                                        segmentColors={["#ff0000", "#ffa500", "#ffff00", "#00ff00"]}
                                        // Altura y ancho del velocímetro
                                        width={300}
                                        height={200}
                                        // Mostrar valor actual
                                        valueTextFontSize="16px"
                                        needleColor="#333"
                                        currentValueText={`${surveyData.quickview_claim_survey.totalstructurescore} points (${(
                                            (surveyData.quickview_claim_survey.totalstructurescore / 400) * 100
                                        ).toFixed(2)}%)`} // Leyenda con el porcentaje y valor actual
                                        customSegmentLabels={[
                                            {
                                                text: "Very Poor",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "12px"
                                            },
                                            {
                                                text: "Poor",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "12px"
                                            },
                                            {
                                                text: "Regular",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "12px"
                                            },
                                            {
                                                text: "RSK",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "12px"
                                            },
                                        ]}
                                        ringWidth={40} // Ancho del anillo
                                        needleTransitionDuration={1000} // Animación de la aguja
                                        needleTransition="easeElastic" // Efecto de transición
                                    />
                                </div>

                                <div style={{ textAlign: "center" }}>
                                    <p><strong>Merits of the Claim</strong></p>
                                    <ReactSpeedometer //merits of the claim
                                        className="w-full md:w-auto mx-auto"
                                        // Valor actual
                                        value={surveyData.quickview_claim_survey.hightestmeritpercentage}
                                        // Rango máximo
                                        maxValue={100}
                                        // Rango mínimo
                                        minValue={0}
                                        // Número de segmentos (colores)
                                        segments={4}
                                        // Colores de los segmentos
                                        segmentColors={["#ff0000", "#ffa500", "#ffff00", "#00ff00"]}
                                        // Altura y ancho del velocímetro
                                        width={300}
                                        height={200}
                                        // Mostrar valor actual
                                        valueTextFontSize="16px"
                                        needleColor="#333"
                                        currentValueText={`${surveyData.quickview_claim_survey.hightestmeritpercentage}%`}
                                        customSegmentLabels={[
                                            {
                                                text: "No Merits",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "12px"
                                            },
                                            {
                                                text: "Limited",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "12px"
                                            },
                                            {
                                                text: "Satisfactory",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "12px"
                                            },
                                            {
                                                text: "High",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "12px"
                                            },
                                        ]}
                                        ringWidth={40} // Ancho del anillo
                                        needleTransitionDuration={1000} // Animación de la aguja
                                        needleTransition="easeElastic" // Efecto de transición
                                    />
                                </div>

                                <div style={{ textAlign: "center" }}>
                                    <p><strong>Final Score</strong></p>
                                    <ReactSpeedometer //final score
                                        className="w-full md:w-auto mx-auto"
                                        // Valor actual
                                        value={surveyData.quickview_claim_survey.finalrecoveryscore}
                                        // Rango máximo
                                        maxValue={100}
                                        // Rango mínimo
                                        minValue={0}
                                        // Número de segmentos (colores)
                                        segments={4}
                                        // Colores de los segmentos
                                        segmentColors={["#ff0000", "#ffa500", "#ffff00", "#00ff00"]}
                                        // Altura y ancho del velocímetro
                                        width={300}
                                        height={200}
                                        // Mostrar valor actual
                                        valueTextFontSize="16px"
                                        needleColor="#333"
                                        currentValueText={`${surveyData.quickview_claim_survey.lowerbound}% - ${surveyData.quickview_claim_survey.upperbound}%`} // Leyenda con el valor
                                        customSegmentLabels={[
                                            {
                                                text: "Low Success",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "10px"
                                            },
                                            {
                                                text: "Limited Recovery",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "10px"
                                            },
                                            {
                                                text: "Recoverable (average)",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "8px"
                                            },
                                            {
                                                text: "Good Recovery",
                                                position: "INSIDE",
                                                color: "#000",
                                                fontSize: "10px"
                                            },
                                        ]}
                                        ringWidth={40} // Ancho del anillo
                                        needleTransitionDuration={1000} // Animación de la aguja
                                        needleTransition="easeElastic" // Efecto de transición
                                    />
                                </div>
                            </div>
                        </CardBody>
                    </Card>

                    <Spacer />

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Shipping Documents</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">
                                <CustomSwitch title={"BL/AWB"} data={surveyData.quickview_claim_survey.blawb} />
                                <CustomSwitch title={"Packing List"} data={surveyData.quickview_claim_survey.packinglist} />
                                <CustomSwitch title={"Phyto Certificate"} data={surveyData.quickview_claim_survey.phytocertificate} />
                                <CustomSwitch title={"DUS/DUA"} data={surveyData.quickview_claim_survey.dusdua} />
                                <CustomSwitch title={"Invoice"} data={surveyData.quickview_claim_survey.invoice} />
                                <CustomSwitch title={"Origin Certificate"} data={surveyData.quickview_claim_survey.origincertificate} />
                                <CustomSwitch title={"Booking"} data={surveyData.quickview_claim_survey.booking} />
                                <CustomSwitch title={"Booking with ETA"} data={surveyData.quickview_claim_survey.bookingtwitheta} />
                            </CardBody>
                            <Divider />
                            <CardFooter className="justify-center">
                                <p className="text-md text-default-700">Score: {surveyData.quickview_claim_survey.shippingdocsscore}</p>
                            </CardFooter>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Supporting Evidence</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">
                                <CustomSwitch title={"Harvest Report"} data={surveyData.quickview_claim_survey.harvestreport} />
                                <CustomSwitch title={"QC at reception"} data={surveyData.quickview_claim_survey.qcatreception} />
                                <CustomSwitch title={"QC for finish product"} data={surveyData.quickview_claim_survey.qcforfinishproduct} />
                                <CustomSwitch title={"Loading/Shipping Instructions"} data={surveyData.quickview_claim_survey.loadingshippinginstructions} />
                                <CustomSwitch title={"Stuffing Report"} data={surveyData.quickview_claim_survey.stuffingreport} />
                                <CustomSwitch title={"Stuffing Report with pictures"} data={surveyData.quickview_claim_survey.stuffingreportwithpictures} />
                            </CardBody>
                            <Divider />
                            <CardFooter className="justify-center">
                                <p className="text-md text-default-700">Score: {surveyData.quickview_claim_survey.supportevidencescore}</p>
                            </CardFooter>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Sales Results</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">
                                <CustomSwitch title={"Sales results"} data={surveyData.quickview_claim_survey.salesresults} />
                                <CustomSwitch title={"Proof of Sales (local invoices)"} data={surveyData.quickview_claim_survey.proofofsaleslocalinvoices} />
                                <CustomSwitch title={"Extra expenses with support"} data={surveyData.quickview_claim_survey.extraexpenseswithsupport} />
                                <CustomSwitch title={"Market Prices"} data={surveyData.quickview_claim_survey.marketprices} />
                                <CustomSwitch title={"Credit Note"} data={surveyData.quickview_claim_survey.creditnote} />
                                <CustomSwitch title={"Destruction Certificate"} data={surveyData.quickview_claim_survey.destructioncertificate} />
                                <CustomSwitch title={"Sales Agreement"} data={surveyData.quickview_claim_survey.salesagreement} />
                                <CustomSwitch title={"IVV"} data={surveyData.quickview_claim_survey.ivv} />
                            </CardBody>
                            <Divider />
                            <CardFooter className="justify-center">
                                <p className="text-md text-default-700">Score: {surveyData.quickview_claim_survey.salesresultsscore}</p>
                            </CardFooter>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Claiming Documents</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">
                                <CustomSwitch title={"Notice of Claim"} data={surveyData.quickview_claim_survey.noticeofclaim} />
                                <CustomSwitch title={"QC at Destination"} data={surveyData.quickview_claim_survey.qcatdestination} />
                                <CustomSwitch title={"Survey Inspection"} data={surveyData.quickview_claim_survey.surveyinspection} />
                                <CustomSwitch title={"Loss Calculation"} data={surveyData.quickview_claim_survey.losscalculation} />
                                <CustomSwitch title={"LOA (exporter/insurer)"} data={surveyData.quickview_claim_survey.loaexporterinsurer} />
                                <CustomSwitch title={"AOR (consignee)"} data={surveyData.quickview_claim_survey.aorconsignee} />
                                <CustomSwitch title={"Value Protect (Maersk)"} data={surveyData.quickview_claim_survey.valueprotectmaersk} />
                            </CardBody>
                            <Divider />
                            <CardFooter className="justify-center">
                                <p className="text-md text-default-700">Score: {surveyData.quickview_claim_survey.claimingdocsscore}</p>
                            </CardFooter>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Merits Temp</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">
                                <CustomSwitch title={"Datalogger (Cp Peter/Hlive, etc)"} data={surveyData.quickview_claim_survey.meritstempdatalogger} />
                                <CustomSwitch title={"Thermograph (doors)"} data={surveyData.quickview_claim_survey.thermographdoors} />
                                <CustomSwitch title={"Thermograph (motor)"} data={surveyData.quickview_claim_survey.thermographmotor} />
                                <CustomSwitch title={"Short high/low peak temp (defrost)"} data={surveyData.quickview_claim_survey.shorthighlowpeaktempdefrost} />
                                <CustomSwitch title={"Long high/low peak temp (failure)"} data={surveyData.quickview_claim_survey.longhighlowpeaktempfailure} />
                                <CustomSwitch title={"High temp (only doors)"} data={surveyData.quickview_claim_survey.hightemponlydoors} />
                                <CustomSwitch title={"Damages related to high/low temperature"} data={surveyData.quickview_claim_survey.damagesrelatedtohighlowtemperature} />
                                <CustomSwitch title={"Wrong setting temp"} data={surveyData.quickview_claim_survey.wrongsettingtemp} />
                            </CardBody>
                            <Divider />
                            <CardFooter className="justify-center">
                                <p className="text-md text-default-700">Score: {surveyData.quickview_claim_survey.meritstempscore}%</p>
                            </CardFooter>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Merits Gas (Controlled Atmosphere)</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">
                                <CustomSwitch title={"Datalogger (Cp Peter/Hlive, etc)"} data={surveyData.quickview_claim_survey.meritsgasdatalogger} />
                                <CustomSwitch title={"Gas reading at destination (curtain)"} data={surveyData.quickview_claim_survey.gasreadingatdestinationcurtain} />
                                <CustomSwitch title={"High CO2 level"} data={surveyData.quickview_claim_survey.highco2level} />
                                <CustomSwitch title={"High O2 level"} data={surveyData.quickview_claim_survey.higho2level} />
                                <CustomSwitch title={"Suffocation or bad taste damage"} data={surveyData.quickview_claim_survey.suffocationorbadtastedamage} />
                                <CustomSwitch title={"Damages due high O2 or lack of CA"} data={surveyData.quickview_claim_survey.damagesduehigho2orlackofca} />
                                <CustomSwitch title={"Wrong ventilation lamp setting"} data={surveyData.quickview_claim_survey.wrongventilationlampsetting} />
                            </CardBody>
                            <Divider />
                            <CardFooter className="justify-center">
                                <p className="text-md text-default-700">Score: {surveyData.quickview_claim_survey.meritsgasscore}%</p>
                            </CardFooter>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Merits Delay</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">
                                <CustomSwitch title={"Delay supported by booking"} data={surveyData.quickview_claim_survey.delaysupportedbybooking} />
                                <CustomSwitch title={"Delay due vessel engine breakdown"} data={surveyData.quickview_claim_survey.delayduevesselenginebreakdown} />
                                <CustomSwitch title={"Delay due weather at origin (duly supported)"} data={surveyData.quickview_claim_survey.delaydueweatheratorigindulysupported} />
                                <CustomSwitch title={"Delay due rolling at origin (instructed by shipping line)"} data={surveyData.quickview_claim_survey.delayduerollingatorigininstructedbyshippingline} />
                                <CustomSwitch title={"Damages related with delay"} data={surveyData.quickview_claim_survey.damagesrelatedwithdelay} />
                                <CustomSwitch title={"Delay > 10 days"} data={surveyData.quickview_claim_survey.delaymorethan10days} />
                                <CustomSwitch title={"Delay > 15 days"} data={surveyData.quickview_claim_survey.delaymorethan15days} />
                                <CustomSwitch title={"Delay < 10 days"} data={surveyData.quickview_claim_survey.delaylessthan10days} />
                                <CustomSwitch title={"Delay due CT failure"} data={surveyData.quickview_claim_survey.delayduectfailure} />
                            </CardBody>
                            <Divider />
                            <CardFooter className="justify-center">
                                <p className="text-md text-default-700">Score: {surveyData.quickview_claim_survey.meritsdelayscore}%</p>
                            </CardFooter>
                        </Card>

                    </div>

                    <Spacer />

                    <div className="max-w-full mx-auto">
                        <Card className="w-full">
                            <CardBody>
                                <h2 className="text-2xl font-bold">QuickView Details</h2>
                                <Divider className="my-4" />
                                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                    {quickViewDetails.map((field, index) => (
                                        <div key={index} className="w-full">
                                            <Input
                                                isReadOnly
                                                label={field.label}
                                                value={field.value}
                                                startContent={
                                                    <Icon
                                                        icon={field.icon}
                                                        className="text-default-400 pointer-events-none flex-shrink-0"
                                                    />
                                                }
                                                classNames={{
                                                    label: "text-sm font-medium",
                                                    input: "text-sm"
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <Divider className="my-4" />

                                {/* Comentario General */}
                                <div className="w-full">
                                    <Textarea
                                        startContent={
                                            <Icon
                                                icon="lucide:message-circle-more"
                                                className="text-default-400 pointer-events-none flex-shrink-0"
                                            />
                                        }
                                        isReadOnly
                                        label="Comentario General"
                                        value={surveyData?.quickview_claim_survey?.generalcomments || "No hay comentarios"}
                                        rows={4} // Para mostrar varias líneas de manera compacta
                                        resize="none" // Desactiva el redimensionamiento
                                        classNames={{
                                            label: "text-sm font-medium",
                                            input: "text-sm"
                                        }}
                                        style={{
                                            whiteSpace: 'pre-wrap', // Para mantener los saltos de línea
                                            overflowY: 'auto' // Habilita el scroll vertical si el contenido es demasiado largo
                                        }}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </div>

                    <Spacer />

                    {/* PERDIDA INSURANCE PAYMENT */}
                    {
                        surveyData?.quickview_claim_survey.insurancepayment != null && surveyData?.quickview_claim_survey.insurancepayment !== "" &&
                        surveyData?.quickview_claim_survey.deductible != null && surveyData?.quickview_claim_survey.deductible !== "" &&
                        surveyData?.quickview_claim_survey.not_covered != null && surveyData?.quickview_claim_survey.not_covered !== ""

                        && (
                            <>
                                <div className="max-w-full mx-auto">
                                    <Card className="w-full">
                                        <CardBody>
                                            <h2 className="text-2xl font-bold">
                                                Insurance payment
                                            </h2>
                                            <Divider className="my-4" />
                                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                                { insurancePayment.map((field, index) => (
                                                    <div key={index} className="w-full">
                                                        <Input
                                                            isReadOnly
                                                            label={field.label}
                                                            value={field.value}
                                                            startContent={
                                                                <>
                                                                    {field.icon2 && (
                                                                        <Icon
                                                                            icon={field.icon2}
                                                                            className="text-primary-500 pointer-events-none flex-shrink-0"
                                                                        />
                                                                    )}
                                                                    <Icon
                                                                        icon={field.icon}
                                                                        className="text-default-400 pointer-events-none flex-shrink-0"
                                                                    />
                                                                </>
                                                            }
                                                            classNames={{
                                                                label: "text-sm font-medium",
                                                                input: "text-sm"
                                                            }}
                                                        />
                                                    </div>
                                                ))
                                                }
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                                <Spacer />
                            </>
                        )}

                    {/*CALCULO DE FREE CONSIGNMENT*/}
                    {(surveyData?.quickview_claim_survey.insurancepayment == null || surveyData?.quickview_claim_survey.insurancepayment === "") &&
                        (surveyData?.quickview_claim_survey.deductible == null || surveyData?.quickview_claim_survey.deductible === "") &&
                        (surveyData?.quickview_claim_survey.not_covered == null || surveyData?.quickview_claim_survey.not_covered === "") &&
                        surveyData?.quickview_claim_survey.selected_calculation === "consignment" && (
                            <>
                                <div className="max-w-full mx-auto">
                                    <Card className="w-full">
                                        <CardBody>
                                            <h2 className="text-2xl font-bold">Loss Calculation: Free Consignment</h2>
                                            <Divider className="my-4" />
                                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                                {perdidaCalculadaConsignment.map((field, index) => (
                                                    <div key={index} className="w-full relative">
                                                        {field.hasDropdown ? (
                                                            <Dropdown
                                                                classNames={{
                                                                    base: "bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700",
                                                                    content: "p-2 min-w-[300px] max-h-[300px] overflow-y-auto",
                                                                }}
                                                            >
                                                                <DropdownTrigger>
                                                                    <Input
                                                                        isReadOnly
                                                                        label={field.label}
                                                                        value={field.value}
                                                                        endContent={
                                                                            <ChevronDownIcon className="w-5 h-5 text-gray-500" />
                                                                        }
                                                                        startContent={
                                                                            <>
                                                                                {field.icon2 && (
                                                                                    <Icon
                                                                                        icon={field.icon2}
                                                                                        className="text-primary-500 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                                    />
                                                                                )}
                                                                                <Icon
                                                                                    icon={field.icon}
                                                                                    className="text-default-400 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                                />
                                                                            </>
                                                                        }
                                                                        classNames={{
                                                                            inputWrapper:
                                                                                "group-data-[hover=true]:border-primary-500 group-data-[focus=true]:border-primary-500 cursor-pointer transition-all duration-200 bg-gray-50 dark:bg-gray-900 border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800",
                                                                            label: "text-sm font-medium text-gray-700 dark:text-gray-200",
                                                                            input: "text-sm text-gray-900 dark:text-gray-100",
                                                                            innerWrapper: "items-center",
                                                                        }}
                                                                        description={field.hasDropdown ? "Click to view details" : undefined}
                                                                    />
                                                                </DropdownTrigger>
                                                                <DropdownMenu
                                                                    aria-label="Extra Costs Details"
                                                                    classNames={{
                                                                        base: "p-2",
                                                                        list: "space-y-1",
                                                                    }}
                                                                >
                                                                    {surveyData.extra_costs.map((cost, idx) => (
                                                                        <DropdownItem
                                                                            key={idx}
                                                                            textValue={`${cost.name}: ${cost.value}`}
                                                                            classNames={{
                                                                                base: "rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors",
                                                                                title: "text-gray-900 dark:text-gray-100",
                                                                            }}
                                                                        >
                                                                            <div className="flex justify-between items-center py-1">
                                                                                <span className="text-sm font-medium">{cost.name}</span>
                                                                                <span className="text-sm text-gray-600 dark:text-gray-400">
                                      {new Intl.NumberFormat("es-CL", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                      }).format(parseFloat(cost.value) || 0)}
                                    </span>
                                                                            </div>
                                                                        </DropdownItem>
                                                                    ))}
                                                                </DropdownMenu>
                                                            </Dropdown>
                                                        ) : (
                                                            <Input
                                                                isReadOnly
                                                                label={field.label}
                                                                value={field.value}
                                                                startContent={
                                                                    <>
                                                                        {field.icon2 && (
                                                                            <Icon
                                                                                icon={field.icon2}
                                                                                className="text-primary-500 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                            />
                                                                        )}
                                                                        <Icon
                                                                            icon={field.icon}
                                                                            className="text-default-400 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                        />
                                                                    </>
                                                                }
                                                                classNames={{
                                                                    inputWrapper:
                                                                        "bg-gray-50 dark:bg-gray-900 border-gray-300 dark:border-gray-600",
                                                                    label: "text-sm font-medium text-gray-700 dark:text-gray-200",
                                                                    input: "text-sm text-gray-900 dark:text-gray-100",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                                <Spacer />
                            </>
                        )}

                    {/*PERDIDA CALCULADA FIRM*/}
                    {
                        (surveyData?.quickview_claim_survey.insurancepayment == null || surveyData?.quickview_claim_survey.insurancepayment == "") &&
                        (surveyData?.quickview_claim_survey.deductible == null || surveyData?.quickview_claim_survey.deductible == "") &&
                        (surveyData?.quickview_claim_survey.not_covered == null || surveyData?.quickview_claim_survey.not_covered == "") &&
                        surveyData.quickview_claim_survey.selected_calculation === "firm"
                        && (
                            <>
                                <div className="max-w-full mx-auto">
                                    <Card className="w-full">
                                        <CardBody>
                                            <h2 className="text-2xl font-bold">Loss Calculation: Firm</h2>
                                            <Divider className="my-4" />
                                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                                {perdidaCalculadaFirm.map((field, index) => (
                                                    <div key={index} className="w-full relative">
                                                        {field.hasDropdown ? (
                                                            <Dropdown
                                                                classNames={{
                                                                    base: "bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700",
                                                                    content: "p-2 min-w-[300px] max-h-[300px] overflow-y-auto",
                                                                }}
                                                            >
                                                                <DropdownTrigger>
                                                                    <Input
                                                                        isReadOnly
                                                                        label={field.label}
                                                                        value={field.value}
                                                                        endContent={
                                                                            <ChevronDownIcon className="w-5 h-5 text-gray-500" />
                                                                        }
                                                                        startContent={
                                                                            <>
                                                                                {field.icon2 && (
                                                                                    <Icon
                                                                                        icon={field.icon2}
                                                                                        className="text-primary-500 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                                    />
                                                                                )}
                                                                                <Icon
                                                                                    icon={field.icon}
                                                                                    className="text-default-400 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                                />
                                                                            </>
                                                                        }
                                                                        classNames={{
                                                                            inputWrapper:
                                                                                "group-data-[hover=true]:border-primary-500 group-data-[focus=true]:border-primary-500 cursor-pointer transition-all duration-200 bg-gray-50 dark:bg-gray-900 border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800",
                                                                            label: "text-sm font-medium text-gray-700 dark:text-gray-200",
                                                                            input: "text-sm text-gray-900 dark:text-gray-100",
                                                                            innerWrapper: "items-center",
                                                                        }}
                                                                        description={field.hasDropdown ? "Click to view details" : undefined}
                                                                    />
                                                                </DropdownTrigger>
                                                                <DropdownMenu
                                                                    aria-label="Extra Costs Details"
                                                                    classNames={{
                                                                        base: "p-2",
                                                                        list: "space-y-1",
                                                                    }}
                                                                >
                                                                    {surveyData.extra_costs.map((cost, idx) => (
                                                                        <DropdownItem
                                                                            key={idx}
                                                                            textValue={`${cost.name}: ${cost.value}`}
                                                                            classNames={{
                                                                                base: "rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors",
                                                                                title: "text-gray-900 dark:text-gray-100",
                                                                            }}
                                                                        >
                                                                            <div className="flex justify-between items-center py-1">
                                                                                <span className="text-sm font-medium">{cost.name}</span>
                                                                                <span className="text-sm text-gray-600 dark:text-gray-400">
                                                                                  {new Intl.NumberFormat("es-CL", {
                                                                                      minimumFractionDigits: 2,
                                                                                      maximumFractionDigits: 2,
                                                                                  }).format(parseFloat(cost.value) || 0)}
                                                                                </span>
                                                                            </div>
                                                                        </DropdownItem>
                                                                    ))}
                                                                </DropdownMenu>
                                                            </Dropdown>
                                                        ) : (
                                                            <Input
                                                                isReadOnly
                                                                label={field.label}
                                                                value={field.value}
                                                                startContent={
                                                                    <>
                                                                        {field.icon2 && (
                                                                            <Icon
                                                                                icon={field.icon2}
                                                                                className="text-primary-500 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                            />
                                                                        )}
                                                                        <Icon
                                                                            icon={field.icon}
                                                                            className="text-default-400 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                        />
                                                                    </>
                                                                }
                                                                classNames={{
                                                                    inputWrapper:
                                                                        "bg-gray-50 dark:bg-gray-900 border-gray-300 dark:border-gray-600",
                                                                    label: "text-sm font-medium text-gray-700 dark:text-gray-200",
                                                                    input: "text-sm text-gray-900 dark:text-gray-100",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                                <Spacer />
                            </>
                    )}

                    <Card className="w-full">
                        <CardBody>
                            <h2 className="text-2xl font-bold">Supporting Documents</h2>
                            {approveView === true && (
                                <h4>Selecciona los documentos visibles para la naviera</h4>
                            )}
                            {!approveView && (
                                <div className="flex justify-end mb-2">
                                    <Button
                                        variant="ghost"
                                        color="primary"
                                        onClick={() => setEditEnabled(!editEnabled)}
                                        startContent={<Icon icon={editEnabled ? "lucide:lock" : "lucide:unlock"} />}
                                    >
                                        {editEnabled ? "Lock edition" : "Edit documents"}
                                    </Button>
                                </div>
                            )}
                            {(approveView || (editEnabled && !rowAprobado)) && (
                                <>
                                    <div className="flex items-center justify-start mb-4 gap-4">
                                        <Button
                                            color="primary"
                                            variant="flat"
                                            onClick={() => document.getElementById('upload-input')?.click()}
                                            startContent={<Icon icon="lucide:upload" />}
                                        >
                                            Select files
                                        </Button>

                                        <input
                                            id="upload-input"
                                            type="file"
                                            multiple
                                            className="hidden"
                                            onChange={(e) => {
                                                const files = Array.from(e.target.files);
                                                setFilesToUpload(prev => [...prev, ...files]);
                                            }}
                                        />

                                        <Button
                                            color="success"
                                            isDisabled={filesToUpload.length === 0}
                                            onClick={async () => {
                                                setIsBusy(true);
                                                try {
                                                    const formData = new FormData();
                                                    filesToUpload.forEach(file => formData.append("files", file));
                                                    formData.append("rsk_ref", rskRef); // o cualquier otro dato relevante

                                                    const response = await apiClient.post("/claims/upload", formData, {
                                                        headers: {
                                                            "Content-Type": "multipart/form-data"
                                                        }
                                                    });

                                                    console.log("Respuesta de subida:", response.data);
                                                    setFilesToUpload([]);
                                                    // Opcional: refrescar attachments
                                                    const updatedSurvey = await apiClient.get(`/quickview/claimsurvey?column=rsk_ref&value=${rskRef}`);
                                                    setSurveyData(updatedSurvey.data);
                                                } catch (err) {
                                                    console.error("Error al subir archivos:", err);
                                                } finally {
                                                    setIsBusy(false);
                                                }
                                            }}
                                        >
                                            Upload files
                                        </Button>
                                    </div>

                                    {filesToUpload.length > 0 && (
                                        <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                                            {filesToUpload.map((file, idx) => (
                                                <div key={idx} className="p-3 border rounded flex items-center justify-between">
                                                    <span className="truncate max-w-[70%]">{file.name}</span>
                                                    <Button
                                                        size="sm"
                                                        color="danger"
                                                        variant="light"
                                                        onClick={() => {
                                                            setFilesToUpload(prev => prev.filter((_, i) => i !== idx));
                                                        }}
                                                    >
                                                        Remove
                                                    </Button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            )}



                            <Divider className="my-2" />
                            <h4 className="mt-4 mb-3 font-bold">Documentos</h4>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                {surveyData.attachments &&
                                surveyData.attachments.filter(file => !file.mimetype?.startsWith('image/')).length > 0 ? (
                                    surveyData.attachments
                                        .filter(file => !file.mimetype?.startsWith('image/')) // Filtra todos los archivos que NO sean imágenes
                                        .map((file, index) => {
                                            const isPDF = file.mimetype === 'application/pdf';
                                            const isWord =
                                                file.mimetype === 'application/msword' ||
                                                file.mimetype === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                                            const isExcel =
                                                file.mimetype === 'application/vnd.ms-excel' ||
                                                file.mimetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                                            return (
                                                <div
                                                    key={file.id || index}
                                                    className="flex flex-col items-center text-center cursor-pointer"
                                                    onClick={() => openFileModal(file)}
                                                >
                                                    {/* Checkbox a la izquierda */}
                                                    <div className="flex items-center">
                                                        <Checkbox
                                                            isDisabled={
                                                                (approveView && rowAprobado) || (!approveView && (!editEnabled || rowAprobado))
                                                            }
                                                            isSelected={file.visible}
                                                            onClick={(e) => e.stopPropagation()} // Evitar que el click se propague
                                                            onChange={(e) => {
                                                                e.stopPropagation(); // Evita la propagación hacia el div padre
                                                                handleCheckboxChange(file.id); // Cambia el estado "visible"
                                                            }}
                                                        >
                                                            {file.visible ? "Visible" : "Oculto"}
                                                        </Checkbox>
                                                    </div>

                                                    <Spacer />


                                                    {/*iconos para el tipo de archivo*/}
                                                    {isPDF ? (
                                                        <FaFilePdf size={100} className="text-red-600" />
                                                    ) : isWord ? (
                                                        <FaFileWord size={100} className="text-blue-600" />
                                                    ) : isExcel ? (
                                                        <FaFileExcel size={100} className="text-green-600" />
                                                    ) : (
                                                        <p className="text-gray-500">Formato no soportado</p>
                                                    )}
                                                    <div className="mt-2">
                                                        <p>
                                                            <strong>
                                                                {file.filename
                                                                    ? file.filename.split('-').slice(5).join('-')
                                                                    : 'Sin nombre'}
                                                            </strong>
                                                        </p>
                                                        {/* <p className="text-sm text-gray-600">
                                                            Peso: {(file.archivo_peso / 1024).toFixed(2)} KB
                                                        </p> */}
                                                        {(approveView || (editEnabled && !rowAprobado)) && (
                                                            <Button
                                                                size="sm"
                                                                color="danger"
                                                                variant="light"
                                                                onClick={async (e) => {
                                                                    e.stopPropagation();

                                                                    if (!window.confirm("¿Estás seguro de que deseas eliminar este archivo?")) return;

                                                                    setIsBusy(true);
                                                                    try {
                                                                        await apiClient.delete(`/claims/file/${file.id}`);

                                                                        toast.success("Archivo eliminado correctamente");

                                                                        // Refrescar los archivos
                                                                        const updatedSurvey = await apiClient.get(`/quickview/claimsurvey?column=rsk_ref&value=${rskRef}`);
                                                                        setSurveyData(updatedSurvey.data);
                                                                    } catch (err) {
                                                                        console.error("Error al eliminar archivo:", err);
                                                                        toast.error("❌ Error al eliminar archivo");
                                                                    } finally {
                                                                        setIsBusy(false);
                                                                    }
                                                                }}
                                                                className="mt-2"
                                                            >
                                                                Remove
                                                            </Button>

                                                        )}

                                                    </div>
                                                </div>
                                            );
                                        })
                                ) : (
                                    <p>No hay documentos disponibles.</p>
                                )}
                            </div>

                            <h4 className="mt-4 mb-3 font-bold">Imágenes</h4>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                {surveyData.attachments && surveyData.attachments.filter(file => file.mimetype?.startsWith('image/')).length > 0 ? (
                                    surveyData.attachments
                                        .filter((file) => file.mimetype?.startsWith('image/'))
                                        .map((image, index) => (
                                            <div
                                                key={image.id || index} // Clave única para React
                                                className="flex flex-col items-center text-center"
                                            >
                                                {/* Checkbox para las imágenes */}
                                                <div className="flex items-center">
                                                    <Checkbox
                                                        isDisabled={
                                                            (approveView && rowAprobado) || (!approveView && (!editEnabled || rowAprobado))
                                                        }
                                                        isSelected={image.visible}
                                                        onClick={(e) => e.stopPropagation()} // Evitar que el click se propague
                                                        onChange={(e) => {
                                                            e.stopPropagation(); // Evita la propagación hacia el div padre
                                                            handleCheckboxChange(image.id); // Cambia el estado "visible"
                                                        }}
                                                    >
                                                        {image.visible ? "Visible" : "Oculto"}
                                                    </Checkbox>
                                                </div>

                                                <Spacer />

                                                {/* Imagen */}
                                                <Image
                                                    isZoomed
                                                    isBlurred
                                                    alt={`Attachment Image ${index + 1}`}
                                                    src={`${filesEndpoint}${image.filename}?thumb=true`}
                                                    height={200}
                                                    className="cursor-pointer"
                                                    onClick={() => handleImageClick(`${image.filename}`)}
                                                />

                                                {(approveView || (editEnabled && !rowAprobado)) && (
                                                    <Button
                                                        size="sm"
                                                        color="danger"
                                                        variant="light"
                                                        onClick={async (e) => {
                                                            e.stopPropagation();

                                                            if (!window.confirm("¿Estás seguro de que deseas eliminar este archivo?")) return;

                                                            setIsBusy(true);
                                                            try {
                                                                await apiClient.delete(`/claims/file/${image.id}`);

                                                                toast.success("Archivo eliminado correctamente");

                                                                // Refrescar los archivos
                                                                const updatedSurvey = await apiClient.get(`/quickview/claimsurvey?column=rsk_ref&value=${rskRef}`);
                                                                setSurveyData(updatedSurvey.data);
                                                            } catch (err) {
                                                                console.error("Error al eliminar archivo:", err);
                                                                toast.error("❌ Error al eliminar archivo");
                                                            } finally {
                                                                setIsBusy(false);
                                                            }
                                                        }}
                                                        className="mt-2"
                                                    >
                                                        Remove
                                                    </Button>

                                                )}
                                            </div>
                                        ))
                                ) : (
                                    <p>No hay imágenes disponibles.</p>
                                )}
                            </div>
                            
                            <Spacer />


                            <div className="flex justify-end mt-4">
                                <DownloadZipButton files={surveyData?.attachments} endpoint={filesEndpoint} fileName={surveyData?.maestra.rsk_ref} filtrar={false} />
                            </div>

                        </CardBody>
                    </Card>

                    {/* Lightbox para mostrar imagen en alta calidad */}
                    <Lightbox
                        open={open}
                        close={() => setOpen(false)}
                        slides={selectedImage ? [{ src: `${filesEndpoint}${selectedImage}`, downloadFilename: `${selectedImage.split('-').slice(5).join('-')}` }] : []}
                        carousel={{ finite: true }}
                        controller={{ close: true, prev: false, next: false }}
                        plugins={[Zoom, Download]}
                    />

                </div> //div contenido
            )}

            {/* Modal interno para previsualización */}
            {isFileModalOpen && (
                <Modal
                    isOpen={isFileModalOpen}
                    onClose={closeFileModal}
                    size="5xl"
                    className="max-h-[90vh] overflow-y-auto"
                >
                    <ModalContent>
                        {() => (
                            <>
                                <ModalHeader className="flex flex-col gap-1">
                                    {/*{selectedFile?.filename || selectedFile?.filename || 'Sin nombre'}*/}
                                    {selectedFile?.filename
                                        ? selectedFile.filename.split('-').slice(5).join('-')
                                        : 'Sin nombre'}
                                </ModalHeader>
                                <ModalBody>
                                    {selectedFile && (
                                        <>
                                            {/*<p>Peso: {((selectedFile.archivo_peso || selectedFile.imagen_peso || 0) / 1024).toFixed(2)} KB</p>*/}
                                            <p>Formato: {selectedFile.mimetype || 'desconocido'}</p>
                                            <div className="mt-4">
                                                {(selectedFile.mimetype?.startsWith('image/') || !selectedFile.mimetype) ? (
                                                    <img
                                                        src={`${filesEndpoint}${selectedFile.archivo_ruta || selectedFile.imagen_ruta}`}
                                                        alt={selectedFile.filename || selectedFile.filename}
                                                        className="max-w-full h-auto"
                                                    />
                                                ) : selectedFile.mimetype === 'application/pdf' ? (
                                                    <iframe
                                                        src={`${filesEndpoint}${selectedFile.filename}`}
                                                        title={selectedFile.filename}
                                                        className="w-full h-[60vh]"
                                                    />
                                                ) : (
                                                    (selectedFile.mimetype === 'application/msword' ||
                                                        selectedFile.mimetype === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                                                        selectedFile.mimetype === 'application/vnd.ms-excel' ||
                                                        selectedFile.mimetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                                                        selectedFile.mimetype === 'application/x-zip-compressed') ? (
                                                        <p>
                                                            Descarga el archivo:{' '}
                                                            <a
                                                                href={`${filesEndpoint}${selectedFile.filename}`}
                                                                className="text-blue-500"
                                                                download
                                                            >
                                                                Descargar
                                                            </a>
                                                        </p>
                                                    ) : (
                                                        <p>
                                                            Tipo de archivo no soportado en el modal. Descarga el archivo:{' '}
                                                            <a
                                                                href={`${filesEndpoint}${selectedFile.filename}`}
                                                                className="text-blue-500"
                                                                download
                                                            >
                                                                Descargar
                                                            </a>
                                                        </p>
                                                    )
                                                )}
                                            </div>
                                        </>
                                    )}
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" variant="light" onPress={closeFileModal}>
                                        Cerrar
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            )}

        </>
    );
}